import { useCallback } from 'react';
import { PageHeader } from '@/components/shared';
import { useBackofficePageTitle } from '@/lib/page-title';
import { fetchBackofficeInterviews } from '../projects/api';
import { ProjectInterviewsListSection } from '../projects/components';
import type { BackofficeInterviewsResponse } from '../projects/types';

export function BackofficeInterviewsPage() {
  useBackofficePageTitle('Interviews');

  const loadPage = useCallback(
    async (
      searchParams: URLSearchParams,
      signal: AbortSignal
    ): Promise<Pick<BackofficeInterviewsResponse, 'interviews' | 'page'>> => {
      return fetchBackofficeInterviews(searchParams, signal);
    },
    []
  );

  return (
    <main className="min-h-[320px] bg-white p-6 md:p-8" aria-label="Backoffice main content">
      <div className="flex flex-col gap-5">
        <PageHeader>Interviews</PageHeader>
        <ProjectInterviewsListSection
          contextLabel="Backoffice interviews"
          showStudyFilter
          showStudyOwner
          loadPage={loadPage}
        />
      </div>
    </main>
  );
}
